module.exports = __webpack_public_path__ + "img/bannerGreen.4bba8899.jpg";